





































import { defineComponent, PropType } from "@vue/composition-api";
import { mdiArrowRight } from "@mdi/js";

import { formatRich } from "../../service/format";

import Modal from "./Modal.vue";
import Warning from "./Warning.vue";
import InfoButton from "./InfoButton.vue";
import PasswordGenerator from "./PasswordGenerator.vue";

export interface State {
    isOpen: boolean;
    isBusy: boolean;
}

interface Props {
    state: State;
}

export default defineComponent({
    name: "ModalCreateByKeystore",
    components: {
        Modal,
        Warning,
        InfoButton,
        PasswordGenerator
    },
    model: {
        prop: "state",
        event: "change"
    },
    props: { state: (Object as unknown) as PropType<State> },
    setup(props: Props, context) {
        function handleModalChangeIsOpen(isOpen: boolean): void {
            context.emit("change", { ...props.state, isOpen });
        }

        function handleSubmitPassword(password: string): void {
            context.emit("submit", password);
        }

        return {
            handleModalChangeIsOpen,
            handleSubmitPassword,
            mdiArrowRight,
            formatRich
        };
    }
});
